// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"da5450b3","453":"62d3010d","667":"b2c069a6","946":"4f9ae435"}[chunkId] + ".chunk.js");